// src/data/projects/links.js

export const projectLinks = {
    portfolio: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the Personal Portfolio WebApp',
            url: 'https://bonaventurecj.github.io/portfolio/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for the Personal Portfolio WebApp on GitHub',
            url: 'https://github.com/BonaventureCJ/portfolio',
        },
    ],
    bonmart: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of BonMart E-commerce project',
            url: 'https://bonmart.vercel.app/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for BonMart E-commerce project on GitHub',
            url: 'https://github.com/BonaventureCJ/bonmart',
        },
    ],
    yummyRecipes: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the Yummy Recipes Hub',
            url: 'https://bonaventurecj.github.io/yummy-recipes-hub',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for Yummy Recipes Hub on GitHub',
            url: 'https://github.com/BonaventureCJ/yummy-recipes-hub',
        },
    ],
    qrCode: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the QR Code Generator',
            url: 'https://bonaventurecj.github.io/qr-code-generator/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for the QR Code Generator on GitHub',
            url: 'https://github.com/BonaventureCJ/qr-code-generator',
        },
    ],
    githubProfile: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the GitHub Profile Viewer',
            url: 'https://bonaventurecj.github.io/github-profile-locator/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for the GitHub Profile Viewer on GitHub',
            url: 'https://github.com/BonaventureCJ/github-profile-locator',
        },
    ],
    movieSearch: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the Movie Search App (Globeflix)',
            url: 'https://bonaventurecj.github.io/globeflix/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for the Movie Search App (Globeflix) on GitHub',
            url: 'https://github.com/BonaventureCJ/globeflix',
        },
    ],
    legacyPortfolio: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of my original portfolio project',
            url: 'https://bonaventurecj.github.io/portfolio-legacy/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for my original portfolio project on GitHub',
            url: 'https://github.com/BonaventureCJ/portfolio-legacy',
        },
    ],
    nextjsDashboard: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the Next.js Dashboard',
            url: 'https://bonaventure-dashboard.vercel.app/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for the Next.js Dashboard on GitHub',
            url: 'https://github.com/BonaventureCJ/nextjs-dashboard',
        },
    ],
    contactManager: [
        {
            label: 'View live',
            ariaLabel: 'View a live demo of the Contact Manager application',
            url: 'https://contact-manager-bona.vercel.app/',
        },
        {
            label: 'View code',
            ariaLabel: 'View the source code for the Contact Manager on GitHub',
            url: 'https://github.com/BonaventureCJ/contact-manager',
        },
    ],
};
